"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobileNavSub = void 0;
const mobileNavSub = () => {
    let mobileNav = document.querySelector('.main-menu-mobile');
    function open(button, panel) {
        button.setAttribute('aria-expanded', 'true');
        button.classList.add('is-open');
        panel.classList.add('is-visible');
        let panelHeight = panel.querySelector('.main-menu-mobile__sub-list-content').offsetHeight;
        panel.setAttribute('style', 'height: ' + panelHeight + 'px');
    }
    function close(button, panel) {
        button.setAttribute('aria-expanded', 'false');
        button.classList.remove('is-open');
        panel.classList.remove('is-visible');
        panel.setAttribute('style', 'height: 0px');
    }
    const panels = mobileNav.querySelectorAll('[data-nav="panel"]');
    const buttons = mobileNav.querySelectorAll('[data-nav="button"]');
    document.addEventListener('click', function (event) {
        const target = event.target;
        if (!target.matches('[data-nav="button"]')) {
            return;
        }
        let currentPanel = target.closest('.main-menu-mobile__item').querySelector('.main-menu-mobile__sub-list');
        if (currentPanel.classList.contains('is-visible')) {
            close(target, currentPanel);
        }
        else {
            open(target, currentPanel);
        }
    });
};
exports.mobileNavSub = mobileNavSub;
